import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT



export const getListData = (params) => {
  return axios.post(root + '/set/dept/listPage', qs.stringify(params))
}

export const getDeptList = (params) => {
  return axios.post(root + '/set/dept/list', qs.stringify(params))
}

export const listAllStore = (params) => {
  return axios.post(root + '/set/dept/listAllStore', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/dept/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/set/dept/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/set/dept/update', qs.stringify(params))
  } else {
    return axios.post(root + '/set/dept/save', qs.stringify(params))
  }
}

export const updateSimple = (params) => {
  return axios.post(root + '/set/dept/updateSimple', qs.stringify(params))
}

export const independentDept = () => {
  return axios.post(root + '/set/dept/independentDept')
}


export const listWindow = (params) => {
  return axios.post(root + '/order/glassesform/listWindow', qs.stringify(params))
}

//删除行
export const removeWindow = (params) => {
  return axios.post(root + '/order/glassesform/removeWindow', qs.stringify(params))
}

//保存某一行的数据
export const saveTVData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/order/glassesform/updateWindowByunitguid', qs.stringify(params))
  } else {
    return axios.post(root + '/order/glassesform/addWindow', qs.stringify(params))
  }
}



// WEBPACK FOOTER //
// ./src/api/set/dept.js